<template>
<div class="good-cate">
    <Row>
        <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                   <Button @click="addGoodCate" type="success" class="f-r">创建新类别</Button>
                </FormItem> 
            </Form>
        </Col>
    </Row>
    <Table border stripe :columns="columns1" ref="selection" :data="typelist" :loading="dataloading"></Table>
    <!-- 创建新类别 弹层 -->
    <Modal v-model="showCreatTypeModal" title="创建新类别" @on-ok="createType('addCate')" :loading="loading">
        <Form :model="cate" ref="addCate" :rules="cateValidate" action="javascript:void(0)">
            <FormItem label="上级类别" prop="heigher_name">
                <Select filterable clearable v-model="cate.heigher_name" style="width:200px">
                    <Option v-for="(item,key) in selectList" :key="key" :value="item.title" :label="item.title">
                        <span :style="{'color':'#'+(item.level +1)*333, 'padding-left':item.level +'em'}">{{ item.title }}</span>
                    </Option>
                </Select>
            </FormItem>
            <FormItem label="名称" prop="name">
                <Input v-model="cate.name" placeholder />
            </FormItem>
            <FormItem label="缩略图">
                <upload-thumb v-model="cate.thumb" ref="uploadthumb" :defaultList="thumblist" :autoCropWidth="135"
                            :autoCropHeight="135" :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:135*135,大小不超过2M'"></upload-thumb>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input v-model="cate.sort" placeholder />
            </FormItem>

        </Form>
    </Modal>
</div>
</template>

<script>
    import UploadThumb from "../common/thumb"
export default {
    name: "good-cate",
    data() {
        return {
            loading: true,
            dataloading: true,
            // 类别
            cate: {
                name: "", // 当前类别
                sort: "", // 排序
                heigher_name: "" // 上级类别
            },
            formItem:{

            },
            thumblist:[],
            // 类别 规则
            cateValidate: {
                name: [{
                    required: true,
                    message: "类别名称必须填写",
                    trigger: "blur"
                }]
            },
            columns1: [
                {
                    title: "排序",
                    width: 80,
                    key: "sort",
                    fixed: "left"
                },
                {
                    title: "Id",
                    key: "id",
                    width: 80,
                },
                {
                    title: "名称",
                    minWidth: 300,
                    key: "title",
                    render: (h, params) => {
                        return h(
                            "span", {
                                style: {
                                    marginLeft: params.row.left + "px"
                                }
                            },
                            params.row.title
                        );
                    }
                },
                {
                    title: "操作",
                    key: "action",
                    width: 130,
                    align: "left",
                    fixed: 'right',
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button", {
                                    props: {
                                        type: "info",
                                        size: "small"
                                    },
                                    style: {
                                        marginRight: "5px"
                                    },
                                    on: {
                                        click: () => {
                                            this.editType(params.row.id);
                                        }
                                    }
                                },
                                "修改"
                            ),
                            h(
                                "Button", {
                                    props: {
                                        type: "error",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            this.removeType(params.row.id);
                                        }
                                    }
                                },
                                "删除"
                            )
                        ]);
                    }
                }
            ],
            typelist: [], //类别列表
            selectList: [], // 下拉类别
            showCreatTypeModal: false,
            currentId: 0 // 编辑类别，当前类别id
        };
    },
    // 计算
    computed: {},
    // 监听
    watch: {},
    created: function () {
        // 取数据
        this.getTableList();
    },
    components: {
        UploadThumb,
    },
    methods: {
        // 获取产品类别列表
        getTableList: function () {
            var self = this;
            var params = {
                token: this.$store.getters.token
            };
            this.$api.goodcate.list(params).then(res => {
                this.dataloading = false;
                if (res.code == 200) {
                    var d = res.result;
                    var darr = this.dataStyle(d);
                    this.typelist = darr;
                    this.selectList = this.dataFirStyle(d);
                    this.$Message.success(res.msg);
                }
            });
            return;
        },
        // 判断上一级id
        typeParentId: function (val) {
            var parentId;
            if (val) {
                for (var i in this.typelist) {
                    if (this.typelist[i].title == val) {
                        parentId = this.typelist[i].id;
                    }
                }
            } else {
                parentId = 0;
            }
            return parentId;
        },
        // 创建新类别
        addGoodCate: function () {
            this.cate={
                id: null,
                name:'',
                sort:0,
                thumb: '1'
            };
            this.currentId = null;
            this.thumblist = new Array();
            this.showCreatTypeModal = true;
        },
        // 编辑类别
        editType: function (id) {
            this.currentId = id;
            this.showCreatTypeModal = true;
            this.thumblist = new Array();
            this.$api.goodcate.detail({category_id: id}).then(res => {
                    if (res.code == 200) {
                        this.cate.name = res.result.name;
                        this.cate.sort = res.result.sort;
                        this.cate.heigher_name = '';
                        this.cate.thumb = res.result.thumb
                        if(this.cate.thumb!=null && this.cate.thumb != ''){
                            this.thumblist.push({
                                 name:this.cate.thumb,
                                 url:this.cate.thumb,
                                 status:'finished',
                            });
                        }
                        for(var i in this.selectList){
                            if(this.selectList[i].id == res.result.parentid ){
                                this.cate.heigher_name = this.selectList[i].title
                            }
                        }
                    }
                });
        },
        // 提交新类别
        createType: function (name) {
            this.$refs[name].validate(valid => {
                if (valid) {
                    if (this.$refs['uploadthumb'].uploadList.length>0) {
                        this.cate.thumb = this.$refs['uploadthumb'].uploadList[0].url;
                    } else {
                        this.cate.thumb = '1'
                    }
                    let params = {
                        thumb: this.cate.thumb,
                        name: this.cate.name, // 分类名称
                        sort: this.cate.sort, // 分类名称
                        parentid: this.typeParentId(this.cate.heigher_name) // 上级名称id
                    };
                    if(this.currentId==null || this.currentId ==0 || this.currentId ==''){
                         this.$api.goodcate.create(params).then(res => {
                            if (res.code == 200) {
                                this.showCreatTypeModal = false;
                                this.getTableList()
                            }
                        });
                    }else{
                        params.category_id = this.currentId;
                        this.$api.goodcate.edit(params).then(res=>{
                        if(res.code == 200)
                            {
                                this.showCreatTypeModal = false;
                                this.getTableList();
                            }
                        });
                    }
                    this.loading = false;
                            this.$nextTick(()=>{this.loading = true;});
                            this.showCreatTypeModal = false;
                } else {
                    this.$Message.error("请检查输入的信息是否正确！");
                    this.loading = false;
                    this.$nextTick(() => {
                        this.loading = true;
                    });
                }
            });
        },
        // 删除
        removeType: function (id) {
            // 弹出确认框
            this.$Modal.confirm({
                title: "警告",
                content: "<p>是否确定删除该类别？</p>",
                onOk: () => {
                    this.$api.goodcate.remove({
                            category_id: id
                        })
                        .then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                this.getTableList()
                            }
                        });
                }
            });
        },
        // 拼数据结构,显示第一级和第二级全部信息
        dataStyle: function (d) {
            var darr = new Array();
            for (var i = 0; i < d.length; i++) {
                var di = {
                    title: d[i].f_name,
                    id: d[i].f_id,
                    sort: d[i].f_sort,
                    createTime: d[i].f_created_at,
                    left: 0,
                    level: 0
                };
                darr.push(di);
                if (d[i].childs) {
                    for (var j in d[i].childs) {
                        var di_erji = {
                            title: "|-" + d[i].childs[j].s_name,
                            parentTitle: d[i].f_name,
                            id: d[i].childs[j].s_id,
                            sort: d[i].childs[j].s_sort,
                            parentId: d[i].f_id,
                            createTime: d[i].childs[j].s_created_at,
                            parentCreatTime: d[i].f_created_at,
                            level: 1,
                            left: 30
                        };
                        darr.push(di_erji);
                    }
                }
            }
            return darr;
        },
        // 拼数据结构,只显示第一级
        dataFirStyle: function (d) {
            var darr = new Array();
            for (var i = 0; i < d.length; i++) {
                var di = {
                    title: d[i].f_name,
                    id: d[i].f_id,
                    sort: d[i].f_sort,
                    createTime: d[i].f_created_at,
                    left: 0,
                    level: 0
                };
                darr.push(di);
            }    
            return darr
        }
    }
};
</script>